import { useCallback, useState } from "react";

import type { IGoogleAdsAccountOption } from "./use-google-ads-accounts";

interface IUseGoogleAdsAccountSelectionReturn {
    selectedAccount: IGoogleAdsAccountOption | null;
    selectAccount: (account: IGoogleAdsAccountOption) => void;
    resetAccount: () => void;
}

export const useGoogleAdsAccountSelection = (): IUseGoogleAdsAccountSelectionReturn => {
    const [selectedAccount, setSelectedAccount] = useState<IGoogleAdsAccountOption | null>(null);

    const selectAccount = useCallback((account: IGoogleAdsAccountOption) => setSelectedAccount(account), []);
    const resetAccount = useCallback(() => setSelectedAccount(null), []);

    return { selectedAccount, selectAccount, resetAccount };
};
